export default {
  filterSpaceTypeRequiredLabel: '21022019-105513-0000',
  filterDate: '27042016-120243-3939',
  filterTimeFromLabel: '16112018-091233-5309',
  filterTimeUntilLabel: '16112018-091512-8215',
  filterNoOfPeopleLabel: '19122018-152801-0002',
  filterLocationLabel: '22112016-134248-8296',
  filterSearchButtonLabel: '23082016-151245-5252',
  filterUpdateButtonLabel: '15112016-103601-4906',
  filterProduct: '13122016-090834-1111', //Product
  filterPeople: '18112016-101623-2917', //People
  filterPerson: '13122016-154553-6551',
  filterWhere: '18112016-102017-5228', //Where
  filterTime: '22112016-144753-8440', //Time
  searchSortLabel: '29012020-152859-0008', //Sort
  mapLabel: '26082016-113919-6975', //Map
  filterLabel: '17112016-110829-6069', //Filter
  mapView: '18112016-120855-9394',
  viewMap: '07102015-153717-2981',
  closeMap: '05092025-210045-0004',
  filterAdd: '01082016-104007-5504'
};
